// extracted by mini-css-extract-plugin
export var TeamInfo = "TeamInfo-module--TeamInfo--3GrQ5";
export var BulletPoints = "TeamInfo-module--BulletPoints--D_i3z";